import { FC } from 'react';
import { Button, Input, Modal, theme } from 'antd';

import FlexBox from '../../../atoms/FlexBox';
import FlexCol from '../../../atoms/FlexCol';

interface TableViewNameModalProps {
  open: boolean;
  title: string;
  okText: string;
  value: string;
  onValueChange: (value: string) => void;
  onOk: () => void;
  onCancel: () => void;
}

const TableViewNameModal: FC<TableViewNameModalProps> = ({
  open,
  title,
  okText,
  value,
  onValueChange,
  onOk,
  onCancel,
}) => {
  const { token } = theme.useToken();
  const canSubmit = value.trim().length > 0;

  return (
    <Modal
      title={title}
      open={open}
      onCancel={onCancel}
      footer={null}
    >
      <FlexCol noGap stretch style={{ width: '100%' }}>
        <Input
          value={value}
          onChange={(e) => onValueChange(e.target.value)}
          placeholder="View name"
          aria-label="Table view name"
          autoFocus
          onPressEnter={() => {
            if (canSubmit) {
              onOk();
            }
          }}
        />
        <FlexBox noGrow style={{ width: '100%', marginTop: token.margin }}>
          <Button aria-label="Cancel table view name" onClick={onCancel}>
            Cancel
          </Button>
          <Button
            aria-label={okText}
            type="primary"
            disabled={!canSubmit}
            onClick={onOk}
          >
            {okText}
          </Button>
        </FlexBox>
      </FlexCol>
    </Modal>
  );
};

export default TableViewNameModal;


